import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SiteAdmin from '../components/SiteAdmin';
import Page from '../../../components/Page';
import UserSearch from '../components/UserSearch';
import AccountAdmin from '../components/AccountAdmin';
import ProviderAccountAdmin from '../components/ProviderAccountAdmin';
import { useHistory, useRouteMatch } from 'react-router-dom';
import withAdminOnly from '../components/AdminOnly';

const useStyles = makeStyles({
  title: {
    marginBottom: '2rem',
  },
});

const UserAdminPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const match = useRouteMatch();
  const isProvider = match.params && match.params.type === 'provider';
  const uuid = match.params && match.params.uuid;

  const selectUser = (user) => {
    if (user) {
      const account_type = user.is_provider ? 'provider' : 'account';
      history.push('/siteadmin/user/' + account_type + '/' + user.uuid);
    }
  };

  return (
    <Page title="User Admin">
      <SiteAdmin>
        <Typography variant="h6" color="primary" className={classes.title}>User Admin</Typography>
        {!uuid && <UserSearch onEnter={selectUser}/>}
        {uuid && (isProvider ? <ProviderAccountAdmin uuid={uuid}/> : <AccountAdmin uuid={uuid}/>)}
      </SiteAdmin>
    </Page>
  );
};

export default withAdminOnly(UserAdminPage);
